import { type Meta } from "./interfaces";

export async function sendViewContentDatalayerEvent(
  payload: Meta.ViewContentPayload,
) {
  window.gtag({ ecommerce: null });
  window.gtag({
    event: "view_content",
    ...payload,
  });
}
